module.exports = __webpack_public_path__ + "Logo_bottom right-5d0ba96b1dff6db56a6cf742febcdbc6.svg";